/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestEstimateDto } from '../../models/contents-request-estimate-dto';

export interface ContentsRequestEstimateControllerDelete$Params {
  id: string;
}

export function contentsRequestEstimateControllerDelete(http: HttpClient, rootUrl: string, params: ContentsRequestEstimateControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestEstimateDto>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestEstimateControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsRequestEstimateDto>;
    })
  );
}

contentsRequestEstimateControllerDelete.PATH = '/api/contents-request-estimate/{id}';
